"use strict";

exports.__esModule = true;
exports.Filters90 = exports.Filters70 = exports.Filters38 = exports.Filters120 = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var propTypes = {
  /** Size of chip  */
  size: (0, _propTypes.oneOf)(["38", "70", "90", "120"])
};

var Filters38 = function Filters38(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 38 : _ref$size;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "155.6%",
    id: "ChipFilter-2" + size,
    width: "155.6%",
    x: "-16.7%",
    y: "-16.7%"
  }, /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "3",
    dy: "3",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: "2.5"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "1",
    dy: "1",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0"
  }), /*#__PURE__*/_react["default"].createElement("feMerge", null, /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }))), /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "147.2%",
    id: "ChipFilter-3" + size,
    width: "147.2%",
    x: "-12.5%",
    y: "-12.5%"
  }, /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "-2",
    dy: "-2",
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: "-1",
    k3: "1",
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 0.133333333   0 0 0 0 0.133333333   0 0 0 0 0.133333333  0 0 0 1 0"
  })));
};

exports.Filters38 = Filters38;
Filters38.propTypes = propTypes;

var Filters70 = function Filters70(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 70 : _ref2$size;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "218.6%",
    id: "ChipFilter-2" + size,
    width: "220.0%",
    x: "-53.6%",
    y: "-39.3%"
  }, /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "10",
    dy: "10",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: "7.5"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "-10",
    dy: "0",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: "5"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "5",
    dy: "4",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: "2"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0"
  }), /*#__PURE__*/_react["default"].createElement("feMerge", null, /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }))), /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "190.0%",
    id: "ChipFilter-3" + size,
    width: "191.4%",
    x: "-39.3%",
    y: "-25.0%"
  }, /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "-2",
    dy: "-2",
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: "-1",
    k3: "1",
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 0.133333333   0 0 0 0 0.133333333   0 0 0 0 0.133333333  0 0 0 1 0"
  })), /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "102.9%",
    id: "ChipFilter-6" + size,
    width: "102.9%",
    x: "-1.5%",
    y: "-1.5%"
  }, /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "1",
    dy: "1",
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: "-1",
    k3: "1",
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.2 0"
  })));
};

exports.Filters70 = Filters70;
Filters70.propTypes = propTypes;

var Filters90 = function Filters90(_ref3) {
  var _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 90 : _ref3$size;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "192.2%",
    id: "ChipFilter-2" + size,
    width: "193.3%",
    x: "-41.7%",
    y: "-30.6%"
  }, /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "10",
    dy: "10",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: "7.5"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "-10",
    dy: "0",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: "5"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "5",
    dy: "4",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: "2"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0"
  }), /*#__PURE__*/_react["default"].createElement("feMerge", null, /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }))), /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "170.0%",
    id: "ChipFilter-3" + size,
    width: "171.1%",
    x: "-30.6%",
    y: "-19.4%"
  }, /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "-2",
    dy: "-2",
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: "-1",
    k3: "1",
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 0.133333333   0 0 0 0 0.133333333   0 0 0 0 0.133333333  0 0 0 1 0"
  })), /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "102.3%",
    id: "ChipFilter-6" + size,
    width: "102.3%",
    x: "-1.1%",
    y: "-1.1%"
  }, /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "1",
    dy: "1",
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: "-1",
    k3: "1",
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.2 0"
  })));
};

exports.Filters90 = Filters90;
Filters90.propTypes = propTypes;

var Filters120 = function Filters120(_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 120 : _ref4$size;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "170%",
    id: "ChipFilter-2" + size,
    width: "170%",
    x: "-31%",
    y: "-23%"
  }, /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "10",
    dy: "10",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: "7.5"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "-10",
    dy: "0",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: "5"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "5",
    dy: "4",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: "2"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    type: "matrix",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0"
  }), /*#__PURE__*/_react["default"].createElement("feMerge", null, /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/_react["default"].createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }))), /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "153%",
    id: "ChipFilter-3" + size,
    width: "153%",
    x: "-23%",
    y: "-15%"
  }, /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: "1.5"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "-2",
    dy: "-2",
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: "-1",
    k3: "1",
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 0.133   0 0 0 0 0.133   0 0 0 0 0.133  0 0 0 1 0"
  })), /*#__PURE__*/_react["default"].createElement("filter", {
    filterUnits: "objectBoundingBox",
    height: "101.7%",
    id: "ChipFilter-6" + size,
    width: "101.7%",
    x: "-0.8%",
    y: "-0.8%"
  }, /*#__PURE__*/_react["default"].createElement("feGaussianBlur", {
    "in": "SourceAlpha",
    result: "shadowBlurInner1",
    stdDeviation: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("feOffset", {
    dx: "1",
    dy: "1",
    "in": "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/_react["default"].createElement("feComposite", {
    "in": "shadowOffsetInner1",
    in2: "SourceAlpha",
    k2: "-1",
    k3: "1",
    operator: "arithmetic",
    result: "shadowInnerInner1"
  }), /*#__PURE__*/_react["default"].createElement("feColorMatrix", {
    "in": "shadowInnerInner1",
    type: "matrix",
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.2 0"
  })));
};

exports.Filters120 = Filters120;
Filters120.propTypes = propTypes;